import { render, staticRenderFns } from "./stepDetail.vue?vue&type=template&id=f1316690&scoped=true&"
import script from "./stepDetail.vue?vue&type=script&lang=js&"
export * from "./stepDetail.vue?vue&type=script&lang=js&"
import style0 from "./stepDetail.vue?vue&type=style&index=0&id=f1316690&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1316690",
  null
  
)

export default component.exports